import useResponsive from './useResponsive';

export default function useChartSettings(data?: any[]) {
  const isMobile = useResponsive('down', 'sm');

  const base_colors = ['#2F795E', '#7DB25C', '#F6E052', '#FFAC5B', '#FF7F81', '#E46AA8', '#0076FF'];
  const direction = isMobile ? ('row' as const) : ('column' as const);
  const mb = data && data?.length > 5 ? 110 : 80;
  const margin = isMobile ? { bottom: mb, left: 0, right: 0 } : { top: 30, bottom: 30 };

  const position = isMobile
    ? { vertical: 'bottom' as const, horizontal: 'middle' as const }
    : { vertical: 'middle' as const, horizontal: 'right' as const };

  const pieChartSetting = {
    height: 260,
    colors: base_colors,
    margin: margin,
    slotProps: {
      legend: {
        padding: 0,
        labelStyle: { fontSize: 12 },
        position: position,
        direction: direction,
      },
    },
  };

  const barChartSettings = {
    colors: ['#2F795E'],
    height: 220,
    leftAxis: null,
    bottomAxis: null,
    slotProps: {
      legend: {
        seriesToDisplay: [],
      },
    },
    rightAxis: {
      position: 'right' as const,
      disableLine: true,
      disableTicks: true,
      axisId: 'deaultized-y-axis-0',
    },
    margin: { right: 200, left: 0, top: 0, bottom: 0 },
    layout: 'horizontal' as const,
  };

  const doubleChartSettings = {
    height: 200,
    colors: base_colors,
    margin: { left: 0, right: 0, top: 0, bottom: 0 },
    bottomAxis: null,
    leftAxis: null,
    slotProps: {
      legend: {
        seriesToDisplay: [],
      },
    },
  };

  return {
    pieChartSetting,
    barChartSettings,
    doubleChartSettings,
  };
}
